var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#map_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20.186l8.308 2.768V5.3L0 2.53v17.655zM18.691 20.53L27 23.302V5.647l-8.308-2.77V20.53zM9.346 23.301l8.308-3.115V2.53L9.346 5.647V23.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "map_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h27v27H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default "data:image/svg+xml,%3csvg viewBox='0 0 27 27' xmlns='http://www.w3.org/2000/svg'%3e %3cg clip-path='url(%23clip0)'%3e %3cpath d='M0 20.1857L8.30796 22.9543V5.29988L0 2.53125V20.1857Z'/%3e %3cpath d='M18.6914 20.5305L26.9994 23.3012V5.64679L18.6914 2.87608V20.5305Z'/%3e %3cpath d='M9.3457 23.3012L17.6537 20.1857V2.53125L9.3457 5.64674V23.3012Z'/%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0'%3e %3crect width='27' height='27' fill='white'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
export { MemoForwardRef as ReactComponent };